import { createDealerAxios } from 'src/factories/axios-factory';
import { ApplicationNote, DocumentUploadResponse, DocumentDeleteRequest, DocumentSnagDeleteRequest, DocumentUploadRequest} from 'src/types/loan-application/index';

const backendUser = createDealerAxios(process.env.DealersApiUrl!);

const documentService = {
  
  documentUpload(note: ApplicationNote, files: readonly any[]) {
    return new Promise<boolean>((resolve, reject) => {
      const form = new FormData();
      form.append("NoteText", note.text);
      form.append("CreatedBy", note.createdBy);
      form.append("AffiliateUserId", note.affiliateUserId);
      form.append("files", JSON.stringify(files));

      backendUser.post(
        `/application/notes/${note.cosmosId}`,
        form,
        {
          headers: { "Content-Type": "multipart/form-data" }
        },
      ).then(res => {
        if (res.status === 200) {
          resolve(true);
          return;
        }
        resolve(false);
      })
        .catch(error => {
          reject(error);
        })
    })
  },
  documentRequirementUpload(request: DocumentUploadRequest) {
    return new Promise<DocumentUploadResponse>((resolve, reject) => {
      const form = new FormData();
      form.append("requirementType", request.requirementType.toString());
      form.append("requirementId", request.requirementId.toString());
      form.append("requirementTypeId", request.requirementTypeId.toString());
      form.append("dealSheetId", request.dealSheetId.toString());
      form.append("fileName", request.fileName.toString());
      form.append("file", request.file);

      backendUser.post(
        `/document/requirement/upload`,
        form,
        {
          headers: { "Content-Type": "multipart/form-data" }
        },
      ).then(res => {
        if (res.status === 200) {
          resolve(res.data as DocumentUploadResponse);
          return;
        }
        reject(null);
      })
        .catch(error => {
          reject(error);
        })
    })
  },
  documentDownload(documentId: string, brokerReference: number) {
    return new Promise((resolve, reject) => {
      backendUser.get(
        `/document?documentId=${documentId}&brokerReference=${brokerReference}`,
        {
          responseType: "blob"
        }
      ).then(response => {
        let blob = new Blob([response.data]);
        resolve(blob);
      }).catch(error => {
        reject(error)
      })
    })
  },
  documentRequirementDownload(uploadId: number) {
    return new Promise((resolve, reject) => {
      backendUser.get(
        `/document/requirement/${uploadId}`,
        {
          responseType: "blob"
        }
      ).then(response => {
        let blob = new Blob([response.data]);
        resolve(blob);
      }).catch(error => {
        reject(error)
      })
    })
  },
  documentRequirementDelete(request: DocumentDeleteRequest) {
    return new Promise((resolve, reject) => {
      backendUser.delete(
        `/document/requirement?dealSheetId=${request.dealSheetId}&requirementId=${request.requirementId}&requirementType=${request.requirementType}&loanDealId=${request.loanDealId}&isMisc=${request.isMisc}&uploadId=${request.uploadId}`
      ).then(response => {
        console.log("r", response)
        resolve(true);
      }).catch(error => {
        reject(error)
      })
    })
  },
  documentSnagDelete(request: DocumentSnagDeleteRequest) {
    return new Promise((resolve, reject) => {
      backendUser.delete(
        `/document/snag?dealSheetId=${request.dealSheetId}&requirementId=${request.requirementId}&requirementTypeId=${request.requirementType}&loanDealId=${request.loanDealId}&snagTypeId=${request.snagTypeId}`
      ).then(response => {
        console.log("r", response)
        resolve(true);
      }).catch(error => {
        reject(error)
      })
    })
  }
};

export default documentService;


